import {TagsList} from '../../../../shared/types/work';

const convertTagsStringToArray = (
  tags: string | undefined
): TagsList | null => {
  if (!tags) {
    return null;
  }

  const tagsArray = tags
    .split(',')
    .map(tag => tag.trim().toLowerCase())
    .sort();

  return tagsArray;
};

export default convertTagsStringToArray;
